const article = {
    slug: "tao-comme-des-garcons",
    category: "BRAND BUYBACK",
    listTitle: "tao COMME des GARÇONS買取",
    listDescription:
      "tao、tricot COMME des GARÇONS、フリル・レース・刺繍・パッチワーク・過去シーズンのアーカイブ作品まで、tao COMME des GARÇONSの繊細な造形価値を見て査定する専用買取ページ。",
    seo: {
      title:
        "tao COMME des GARÇONS買取｜タオ コムデギャルソンの価値まで査定するEnclopedia",
      description:
        "tao COMME des GARÇONS（タオ コムデギャルソン）の買取ならEnclopediaへ。tao、tricot COMME des GARÇONS、フリル、レース、刺繍、パッチワーク、ワンピース、ブラウス、スカート、ジャケット、アーカイブ作品まで、シーズン背景・造形性・希少性・市場価値を見て査定。LINE事前査定から全国対応の宅配買取へご案内します。",
      keyword:
        "tao COMME des GARCONS 買取,tao COMME des GARÇONS 買取,タオ コムデギャルソン 買取,tao 買取,タオ 買取,tao 高価買取,タオ 高価買取,tao 宅配買取,タオ 宅配買取,tao LINE査定,タオ 買取相場,tricot COMME des GARCONS 買取,tricot COMME des GARÇONS 買取,トリコ コムデギャルソン 買取,コムデギャルソン タオ 買取,コムデギャルソン レディース 買取,tao アーカイブ 買取,フリル ワンピース 買取,レース ブラウス 買取,アーカイブ買取,enclopedia,アンクロペディア",
      canonicalPath: "/brand_buyback/tao-comme-des-garcons",
    },
    hero: {
      label: "TAO COMME DES GARÇONS BUYBACK",
      number: "11 / BUYBACK",
      titleLines: [
        "tao COMME des GARÇONS買取。",
        "繊細な造形価値まで見て査定します。",
      ],
      body:
        "Enclopediaは、tao COMME des GARÇONSをブランド名や型番だけで一律に判断しません。\nフリル、レース、刺繍、パッチワーク、ワンピース、ブラウス、スカート、ジャケット、tricot COMME des GARÇONS時代の作品まで、素材表現・シーズン背景・現在の需要を確認し、個々のアイテムにフォーカスして査定します。\nまずはLINEで無料の事前査定。納得いただけた方を、全国対応の宅配買取へご案内します。",
      primaryCtaLabel: "LINEで事前査定する",
      primaryCtaHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryCtaLabel: "宅配買取を申し込む",
      secondaryCtaHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
      keywords: [
        "tao buyback",
        "tricot archive",
        "lace and frill",
        "comme des garçons",
      ],
      visualLabel: "ARCHIVE VALUATION",
      visualTitle: [
        "可愛い服としてではなく、",
        "構築された繊細さとして見る。",
      ],
      image: "media/archive_fashion/buyback11.png",
      imageAlt: "tao COMME des GARÇONS買取のメイン画像",
    },
    thesis: {
      text:
        "tao COMME des GARÇONSの価値は、ブランド名だけでなく、素材表現・装飾密度・構築性・シーズン背景まで見て判断する。",
      keywords: ["lace", "frill", "archive rarity"],
    },
    intro: {
      label: "02 / OUR BUYBACK VIEW",
      titleLines: [
        "tao COMME des GARÇONSの価値は、",
        "“かわいい服”だけでは測れない。",
      ],
      body:
        "tao COMME des GARÇONSは、フリル、レース、刺繍、パッチワーク、ギャザー、丸みのあるシルエットなどを通じて、柔らかさと構築性を同時に成立させるブランドです。\n甘さのある表現の中にも、COMME des GARÇONSらしい違和感、余白、素材の重なり、身体との距離があります。\nEnclopediaでは、単に人気アイテムかどうかではなく、その一着がtaoの中でどのような素材表現と時代性を持つかまで確認して査定します。",
    },
    valuation: {
      label: "03 / WHAT WE VALUE",
      titleLines: [
        "Enclopediaが重視する、",
        "3つの査定視点。",
      ],
      items: [
        {
          number: "01",
          title: "素材表現を見る",
          text:
            "レース、チュール、コットン、ウール、刺繍、パッチワークなど、taoらしい素材の重なりと表情を確認します。",
        },
        {
          number: "02",
          title: "装飾と構造を見る",
          text:
            "フリル、ギャザー、切替、ボリューム、丸みのあるシルエットが、単なる装飾ではなく服の構造として成立しているかを見ます。",
        },
        {
          number: "03",
          title: "ラインと希少性を見る",
          text:
            "tao、tricot COMME des GARÇONS、過去シーズンのアーカイブなど、ライン・年代・現在需要を分けて判断します。",
        },
      ],
    },
    targetLines: {
      label: "04 / TARGET ITEMS",
      titleLines: [
        "tao COMME des GARÇONS全般を、",
        "幅広く査定します。",
      ],
      items: [
        {
          tag: "ITEM 01",
          title: "tao COMME des GARÇONS",
          text:
            "現行のtaoライン。ワンピース、ブラウス、スカート、パンツ、ジャケット、コートなどを幅広く査定します。",
        },
        {
          tag: "ITEM 02",
          title: "tricot COMME des GARÇONS",
          text:
            "tricot時代の作品も対象です。年代、素材、柄、シルエット、現在需要を踏まえて丁寧に確認します。",
        },
        {
          tag: "ITEM 03",
          title: "ワンピース・ドレス",
          text:
            "フリル、レース、ギャザー、切替、ボリューム感が出やすいカテゴリとして、特に丁寧に見ます。",
        },
        {
          tag: "ITEM 04",
          title: "ブラウス・シャツ",
          text:
            "襟、袖、刺繍、レース、フリルのディテールが強いブラウスやシャツは、taoらしさが評価につながりやすい領域です。",
        },
        {
          tag: "ITEM 05",
          title: "スカート・パンツ",
          text:
            "ボリュームスカート、パッチワーク、チェック、レース使い、丸みのあるパンツなど、造形性のあるボトムスも査定対象です。",
        },
        {
          tag: "ITEM 06",
          title: "ジャケット・コート",
          text:
            "素材切替、装飾、丸いフォルム、COMME des GARÇONSらしい違和感を持つアウター類を確認します。",
        },
        {
          tag: "ITEM 07",
          title: "ニット・カットソー",
          text:
            "日常着に近いアイテムでも、柄、刺繍、素材感、シーズン性によって価値が変わるため個別に見ます。",
        },
        {
          tag: "ITEM 08",
          title: "過去シーズンのアーカイブ",
          text:
            "古いだけで高くなるわけではありませんが、現在も評価される素材表現や希少性のある作品はアーカイブ価値まで見ます。",
        },
      ],
    },
    highValueItems: {
      label: "05 / HIGH VALUE ITEMS",
      titleLines: [
        "高価買取につながりやすい、",
        "tao COMME des GARÇONSのアイテム。",
      ],
      intro:
        "査定額は状態や市場性で変動しますが、Enclopediaでは特に以下のようなtao COMME des GARÇONSを丁寧に確認します。",
      items: [
        {
          index: "01",
          title: "フリル・レース・刺繍が印象的なワンピース",
          text:
            "taoらしい繊細さと造形性が強く出るワンピースやドレスは、状態・素材・シーズン性を踏まえて評価します。",
        },
        {
          index: "02",
          title: "tricot COMME des GARÇONS時代の希少アーカイブ",
          text:
            "過去のtricot作品は、年代、柄、素材、現在需要によって価値が変わります。古さだけでなく着用価値まで確認します。",
        },
        {
          index: "03",
          title: "パッチワーク・チェック・花柄などの象徴的な作品",
          text:
            "視覚的な強さがあり、taoやtricotの世界観が伝わる柄物・切替アイテムは個別に査定します。",
        },
        {
          index: "04",
          title: "保存状態の良いブラウス・スカート・ジャケット",
          text:
            "白や淡色、繊細な素材は状態差が査定に影響します。シミ、黄ばみ、ほつれ、レース破れまで確認します。",
        },
        {
          index: "05",
          title: "近年シーズンの人気作・流通量の少ない品",
          text:
            "現行taoの人気アイテムや、市場で見つかりにくいサイズ・柄・デザインは現在需要を踏まえて判断します。",
        },
      ],
    },
    quote: {
      textLines: [
        "“甘い服”としてではなく、",
        "違和感を含んだ繊細な構造として見る。",
      ],
    },
    assessmentDifference: {
      label: "06 / ASSESSMENT DIFFERENCE",
      titleLines: [
        "一般的な査定で、",
        "見落とされやすいtaoの価値。",
      ],
      intro:
        "tao COMME des GARÇONSは、装飾性が高い一方で、素材や構造の細かな違いが価値に影響するブランドです。",
      items: [
        {
          index: "01",
          title: "フリルやレースを単なる装飾として見ない",
          text:
            "taoの装飾は、服の形や重さ、身体との距離を作る要素です。装飾密度と構造をあわせて確認します。",
        },
        {
          index: "02",
          title: "tricotとtaoを文脈ごとに見る",
          text:
            "同じ系譜の服でも、tricot時代とtaoでは評価軸や需要が異なります。ラインと年代を分けて判断します。",
        },
        {
          index: "03",
          title: "繊細な素材の状態を丁寧に見る",
          text:
            "レース、チュール、白系素材、刺繍、パッチワークは状態差が大きく出ます。次の着用者へ渡せる価値があるかを確認します。",
        },
      ],
    },
    flow: {
      label: "07 / BUYBACK FLOW",
      titleLines: [
        "LINE事前査定から、",
        "宅配買取へ。",
      ],
      items: [
        {
          step: "STEP 01",
          title: "LINEで事前査定",
          text:
            "写真と簡単な情報をお送りください。全体、ブランドタグ、品番タグ、素材表記、装飾部分、汚れやほつれが分かる写真があると確認しやすくなります。",
        },
        {
          step: "STEP 02",
          title: "宅配買取を申込",
          text:
            "本査定をご希望の場合は申込フォームへ。宅配キットの要否もここで選択できます。",
        },
        {
          step: "STEP 03",
          title: "無料で発送",
          text:
            "送料は無料。レースやフリルなど繊細な装飾がある場合は、なるべく形を崩さない梱包をおすすめします。",
        },
        {
          step: "STEP 04",
          title: "本査定・ご入金",
          text:
            "到着後に状態・真贋・市場性・アーカイブ価値を確認。金額にご納得いただければご指定口座へ入金します。",
        },
      ],
    },
    assurance: {
      label: "08 / SAFE BUYBACK",
      titleLines: [
        "相談しやすく、",
        "進めやすいtao COMME des GARÇONS買取。",
      ],
      intro:
        "LINEで相談してから進められるため、繊細な素材や過去シーズンのアイテムも、宅配買取へ進む前に確認できます。",
      items: [
        {
          title: "LINE事前査定あり",
          text:
            "まず相談してから進められるため、状態や市場性に不安がある品も事前に確認できます。",
        },
        {
          title: "送料は無料",
          text:
            "宅配買取の発送費用はEnclopediaが負担します。",
        },
        {
          title: "宅配キットは選択制",
          text:
            "必要な方には宅配キットをご用意。ご自身で梱包できる場合はそのまま発送可能です。",
        },
        {
          title: "キャンセル返送料は基本無料",
          text:
            "査定金額にご納得いただけない場合の返送も基本無料です。",
        },
      ],
      notice:
        "キャンセル返送料は基本無料です。ただし、お送りいただいた品がすべてコピー品、または真贋判定不可品のみだった場合は、返送料をご負担いただく場合があります。",
    },
    faq: {
      label: "09 / FAQ",
      titleLines: [
        "tao COMME des GARÇONS買取で、",
        "よくあるご質問。",
      ],
      items: [
        {
          question:
            "どのtao COMME des GARÇONSアイテムを買取していますか？",
          answer:
            "ワンピース、ブラウス、スカート、パンツ、ジャケット、コート、ニット、カットソー、小物まで幅広くご相談いただけます。",
        },
        {
          question:
            "tricot COMME des GARÇONSも査定できますか？",
          answer:
            "はい。tricot COMME des GARÇONSも査定対象です。年代、素材、柄、状態、現在需要を確認して個別に判断します。",
        },
        {
          question:
            "フリルやレースのある服は高く売れますか？",
          answer:
            "状態・デザイン・シーズン性・現在需要によって変動しますが、taoらしい素材表現や装飾性が強いアイテムは丁寧に評価します。",
        },
        {
          question:
            "白や淡色のアイテムに少し汚れがあります。査定できますか？",
          answer:
            "査定可能です。シミ、黄ばみ、ほつれ、レース破れなどの状態を確認したうえで、再流通価値を判断します。",
        },
        {
          question:
            "古いtaoやtricotのアーカイブも買取できますか？",
          answer:
            "はい。年代だけで一律には判断せず、希少性、素材表現、柄、現在の需要を踏まえて個別に査定します。",
        },
        {
          question:
            "tao COMME des GARÇONSの買取相場を先に知りたいです。",
          answer:
            "まずはLINEで写真をお送りください。ライン、品番、状態、サイズ、素材、現在需要を確認し、宅配買取へ進む前に大まかな方向性をご案内します。",
        },
      ],
    },
    finalCta: {
      titleLines: [
        "まずはLINEで、",
        "tao COMME des GARÇONSの価値をご相談ください。",
      ],
      body:
        "tao、tricot COMME des GARÇONS、フリル、レース、刺繍、ワンピース、アーカイブ作品まで確認。\nEnclopediaが、繊細な造形と再流通価値を見て宅配買取へ丁寧につなげます。",
      primaryLabel: "LINEで事前査定する",
      primaryHref: "https://line.me/R/ti/p/@240yzqkh",
      secondaryLabel: "宅配買取を申し込む",
      secondaryHref:
        "https://www.enclopedia-official.com/kaitori/takuhai",
    },
  };

export default article;
